module.exports = __webpack_public_path__ + "static/media/soleil.6e1249cd.jpg";